import React from 'react';
import Hero from './Hero';
import servicesBcg from '../images/servicesBcg.jpeg';

export default function Services() {
  return (
    <div>
      <Hero img={servicesBcg}/>
    </div>
  )
}

